const initialValue = {
  customerId: '',
  pickupDate: '',
};

export default initialValue;
